import { Request } from './Request';

export interface IUpdateSiteStartPageParams {
  startPage: string;
}

export interface IUpdateStringServerSettingResult {
}

export class UpdateSiteStartPageRequest extends Request<IUpdateSiteStartPageParams, IUpdateStringServerSettingResult> {
  constructor(params: IUpdateSiteStartPageParams) {
    super('updateSiteStartPage', params);
  }
}
